import React, { useEffect, useState } from "react";
import api from "@api";
import { NavLink, useParams } from "react-router-dom";
import "./DirectoryLeaguePlayers.css";

function DirectoryLeaguePlayers() {
 const { leagueNameAndId } = useParams();
 const directoryLeagueId = leagueNameAndId?.split("-").pop();

 const [league, setLeague] = useState(null);
 const [playersPage, setPlayersPage] = useState(null);
 const [playerSearch, setPlayerSearch] = useState("");
 const [loading, setLoading] = useState(true);

 useEffect(() => {
  const fetchLeague = async () => {
   try {
    const res = await api.get(`/api/directory/leagues/${directoryLeagueId}`);
    setLeague(res.data);
   } catch (err) {
    console.error("Failed to fetch league players page", err);
   }
  };

  const fetchPlayers = async () => {
   try {
    const res = await api.get(
     `/api/directory/leagues/${directoryLeagueId}/players`
    );
    setPlayersPage(res.data);
   } catch (err) {
    console.error("Failed to fetch directory players", err);
   } finally {
    setLoading(false);
   }
  };

  fetchLeague();
  fetchPlayers();
 }, [directoryLeagueId]);

 const players = (playersPage?.players || []).sort((a, b) =>
  a.playerName.localeCompare(b.playerName)
 );
 const filteredPlayers = players.filter((player) => {
  const search = playerSearch.toLowerCase();

  return (
   player.playerName?.toLowerCase().includes(search) ||
   player.teamName?.toLowerCase().includes(search)
  );
 });

 return (
  <div className="league-profile-page">
   <div className="league-profile-container">
    <div className="league-profile-public-tabs">
     <NavLink end to={`/leagues/${leagueNameAndId}`}>
      Overview
     </NavLink>

     <NavLink to={`/leagues/${leagueNameAndId}/schedule`}>
      Schedule
     </NavLink>

     <NavLink to={`/leagues/${leagueNameAndId}/standings`}>
      Standings
     </NavLink>

     <NavLink to={`/leagues/${leagueNameAndId}/players`}>
      Players
     </NavLink>
    </div>

    <div className="league-profile-card directory-players-card">
     <div className="directory-players-header">
      <h1 className="directory-players-title">
       {league?.name} Players
      </h1>

      <input
       type="text"
       value={playerSearch}
       onChange={(e) => setPlayerSearch(e.target.value)}
       placeholder="Search players..."
       className="directory-players-search"
      />
     </div>

     {playersPage?.locked ? (
      <div className="directory-players-empty">
       Players are available with League Tools.
      </div>
     ) : filteredPlayers.length > 0 ? (
      <div className="directory-players-table">
       <div className="directory-players-table-header">
        <div>Player</div>
        <div>Team</div>
       </div>

        {filteredPlayers.map((player) => (
         <NavLink
          key={player.rosterId}
          to={`/leagues/${leagueNameAndId}/players/${player.rosterId}`}
          className="directory-players-row"
         >
          <div className="directory-players-name">
           {player.playerName}
          </div>

          <div className="directory-players-team-name">
           {player.teamName}
          </div>
         </NavLink>
        ))}
      </div>
     ) : (
      <div className="directory-players-empty">
       No players have been added yet.
      </div>
     )}
    </div>
   </div>
  </div>
 );
}

export default DirectoryLeaguePlayers;